import type { IconProps } from './types';

const ThumbsUpIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 16, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path
        d="M2.625 22.3125V11.0625M17.625 21.375L21.9272 9.1875H12.9375V6C12.9375 4.13603 11.4264 2.625 9.5625 2.625H8.71875L6.375 11.0625V21.375H17.625Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export { ThumbsUpIcon };
